import { mode } from '@chakra-ui/theme-tools';

const Card = {
  baseStyle: (props: any) => ({
    p: '24px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    position: 'relative',
    borderRadius: '12px',
    minWidth: '0px',
    wordWrap: 'break-word',
    bg: mode('#ffffff', 'navy.800')(props),
    boxShadow: mode(
      '0px 2px 8px rgba(0, 0, 0, 0.04), 0px 1px 2px rgba(0, 0, 0, 0.06)',
      '0px 4px 12px rgba(0, 0, 0, 0.15)'
    )(props),
    backgroundClip: 'border-box',
    border: '1px solid',
    borderColor: mode('secondaryGray.200', 'rgba(255, 255, 255, 0.12)')(props),
    transition: 'all 0.2s ease-in-out',
    _hover: {
      transform: 'translateY(-2px)',
      boxShadow: mode(
        '0px 4px 16px rgba(0, 0, 0, 0.08), 0px 2px 4px rgba(0, 0, 0, 0.06)',
        '0px 8px 20px rgba(0, 0, 0, 0.25)'
      )(props),
    },
  }),
  variants: {
    elevated: (props: any) => ({
      bg: mode('#ffffff', 'navy.700')(props),
      boxShadow: mode(
        '0px 4px 16px rgba(0, 0, 0, 0.06), 0px 2px 4px rgba(0, 0, 0, 0.04)',
        '0px 8px 24px rgba(0, 0, 0, 0.2)'
      )(props),
      borderColor: mode('transparent', 'rgba(255, 255, 255, 0.1)')(props),
    }),
    outline: (props: any) => ({
      bg: 'transparent',
      borderColor: mode('brand.200', 'brand.600')(props),
      borderWidth: '2px',
      boxShadow: 'none',
      _hover: {
        bg: mode('brand.50', 'brand.900')(props),
        borderColor: mode('brand.300', 'brand.500')(props),
      },
    }),
    subtle: (props: any) => ({
      bg: mode('background.50', 'navy.900')(props),
      borderColor: mode('transparent', 'transparent')(props),
      boxShadow: 'none',
    }),
  },
};

export const CardComponent = {
  components: {
    Card,
  },
}; 